/** Stable URLs you can declare in Razorpay / PSP dashboards and customer emails. */
export const LEGAL_NAV_LINKS = [
  { to: "/terms", label: "Terms" },
  { to: "/privacy-policy", label: "Privacy" },
  { to: "/cookie-policy", label: "Cookies" },
  { to: "/shipping-policy", label: "Shipping" },
  { to: "/refund-policy", label: "Refunds" },
];
